import React from "react";
import styled from "styled-components";
import Flex from "../core/Flex";

function AdminPage({ children, ...props }) {
  return (
    <Page {...props}>
      {children}
    </Page>
  );
}

const Page = styled(Flex)`
  width: 100%;
  height: 100%;
  padding: 48px;
  background-color: var(--aia-bx-gray-10);
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  overflow-y: auto;
`;

export default AdminPage;